import Vue from 'vue'
import { YbiService } from '@/utvStore/components/VideoPlayer/utils/ybiService'

class VideoLogger {
  constructor(video, data, vnode) {
    this.ybiService = null
    this.timer = null
    this.vnode = vnode
    //this.ybiService = new YbiService()
    video.addEventListener('play', this.setSendLogTimer.bind(this))
    video.addEventListener('pause', this.unsetSendLogTimer.bind(this))
    video.addEventListener('ended', this.unsetSendLogTimer.bind(this))
  }

  setSendLogTimer() {
    if (!this.vnode.context.isStreamingAd) {
      const TEN_SECONDS = 10 * 1000
      this.sendPostPlayVod()
      this.unsetSendLogTimer()
      this.timer = setInterval(this.sendPostPlayVod.bind(this), TEN_SECONDS)
    } else {
      this.unsetSendLogTimer()
    }
  }

  unsetSendLogTimer() {
    if (!this.timer) {
      return
    }
    clearInterval(this.timer)
    this.timer = null
  }

  sendPostPlayVod() {
    //this.ybiService.postPlayVod(...Object.keys(this.data).map(key => this.data[key]))
  }
}

Vue.directive('videoLogger', {
  inserted(el, binding, vnode) {
    new VideoLogger(el, binding.value, vnode)
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/videoLogger.js